import React from "react";
import {Title} from "./Title";

export const DefaultEditProps = ({resource}) => {
    return {
        title: <Title resource={resource}/>,
        undoable: false,
    };
};
